import React from 'react';
import { Reveal } from './showcase/Reveal';
import { SmsVignette } from './showcase/SmsVignette';
import { AgreementVignette } from './showcase/AgreementVignette';
export function WorkingExamples() {
  return <section id="working" aria-labelledby="working-title" className="border-b border-white/5 bg-ink-900" data-id="element-536" data-mp="3mk0f0xlf6cjn">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-537" data-mp="3hnigifgonafr">
        <Reveal data-id="element-538" data-mp="j30goohblg93">
          <h2 id="working-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-539" data-mp="j3jnpa5fmk8c">
            What it looks like when it works.
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-8 lg:grid-cols-2" data-id="element-540" data-mp="54k6uoo5v9mq">
          <Reveal delay={0.05} data-id="element-541" data-mp="540nr4mryf74">
            <SmsVignette data-id="element-542" data-mp="2tvuxejpnx3o1" />
            <p className="mt-4 text-sm text-white/55" data-id="element-543" data-mp="2tx5z8dzjs1ci">
              A portal form fill, answered in 45 seconds.
            </p>
          </Reveal>
          <Reveal delay={0.12} data-id="element-544" data-mp="2pwm0j5zbspo9">
            <AgreementVignette data-id="element-545" data-mp="1n050h5tp6gqp" />
            <p className="mt-4 text-sm text-white/55" data-id="element-546" data-mp="1n1y6qk0eeyy6">
              The touring agreement, signed before the showing.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}